// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"006dd775","488":"4b7c086e","732":"521d658e","977":"3a98b9ac"}[chunkId] + ".chunk.js";
};